function ChatbotIcon() {
  return (
    <div style={{ backgroundColor: '#06F', borderRadius: 9, textAlign: 'center' }}>
      <svg
        width='28'
        height='28'
        viewBox='0 0 28 28'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='chatbot-line'>
          <path
            id='Vector 19'
            d='M6.125 14.2813C6.125 13.9706 5.87316 13.7188 5.5625 13.7188C5.25184 13.7188 5 13.9706 5 14.2813H6.125ZM5 18.3702C5 18.6809 5.25184 18.9327 5.5625 18.9327C5.87316 18.9327 6.125 18.6809 6.125 18.3702H5ZM23 14.2813C23 13.9706 22.7482 13.7188 22.4375 13.7188C22.1268 13.7188 21.875 13.9706 21.875 14.2813H23ZM21.875 18.3702C21.875 18.6809 22.1268 18.9327 22.4375 18.9327C22.7482 18.9327 23 18.6809 23 18.3702H21.875ZM7.25 15.2764V17.375H8.375V15.2764H7.25ZM12.3125 22.4375H15.6875V21.3125H12.3125V22.4375ZM20.75 17.375V15.2764H19.625V17.375H20.75ZM15.6875 10.2139H14V11.3389H15.6875V10.2139ZM14 10.2139H12.3125V11.3389H14V10.2139ZM14.5625 10.7764V6.6875H13.4375V10.7764H14.5625ZM5 14.2813V18.3702H6.125V14.2813H5ZM21.875 14.2813V18.3702H23V14.2813H21.875ZM15.6875 22.4375C18.4834 22.4375 20.75 20.1709 20.75 17.375H19.625C19.625 19.5496 17.8621 21.3125 15.6875 21.3125V22.4375ZM7.25 17.375C7.25 20.1709 9.51656 22.4375 12.3125 22.4375V21.3125C10.1379 21.3125 8.375 19.5496 8.375 17.375H7.25ZM8.375 15.2764C8.375 13.1018 10.1379 11.3389 12.3125 11.3389V10.2139C9.51656 10.2139 7.25 12.4805 7.25 15.2764H8.375ZM20.75 15.2764C20.75 12.4805 18.4834 10.2139 15.6875 10.2139V11.3389C17.8621 11.3389 19.625 13.1018 19.625 15.2764H20.75Z'
            fill='white'
          />
          <circle id='Ellipse 2813' cx='16.25' cy='16.25' r='1.125' fill='white' />
          <circle id='Ellipse 2814' cx='11.75' cy='16.25' r='1.125' fill='white' />
          <circle id='Ellipse 2815' cx='14' cy='6.6875' r='1.6875' fill='white' />
        </g>
      </svg>
    </div>
  );
}

export default ChatbotIcon;
